import { useMutation } from '@apollo/client'
import {
  CheckInsuranceEligibility,
  CheckUserEligibilityInput,
  CheckInsuranceEligibilityVariables,
} from '../../types'
import { CHECK_INSURANCE_ELIGIBILITY } from './operations'

interface CheckInsuranceEligibilityProps {
  onCompleted?: (data: CheckInsuranceEligibility) => void
  filter?: CheckUserEligibilityInput
}

export const useCheckInsuranceEligibility = ({ onCompleted }: CheckInsuranceEligibilityProps) =>
  useMutation<CheckInsuranceEligibility, CheckInsuranceEligibilityVariables>(
    CHECK_INSURANCE_ELIGIBILITY,
    {
      onCompleted,
    }
  )
